const errors = {
	errorForm(obj, field) {
		let erro = '';
		if (obj[field]) {
			erro = obj[field];
		}
		// console.log(erro, '1');
		return erro;
	},
	genericError(obj) {
		const erro = obj.error;
		// console.log(erro, '2');
		return erro;
	},
};

export { errors as default };



// WEBPACK FOOTER //
// ./_source/javascripts/methods/errors.js